// devToolsExchange should come first: https://github.com/FormidableLabs/urql-devtools-exchange#usage

import { devtoolsExchange } from '@urql/devtools';
import { createClient, defaultExchanges } from 'urql';

// Default Exchanges are dedupExchange, cachExchange, fetchExchange: https://formidable.com/open-source/urql/docs/architecture/
export const client = createClient({
  url: window.env.GRAPHQL_ENDPOINT,
  exchanges: [devtoolsExchange, ...defaultExchanges],
  fetchOptions: () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem('authToken') ?? ''}`,
      'apollographql-client-name': window.env.GRAPHQL_CLIENT_NAME,
      'apollographql-client-version': '1.0.0',
    },
    credentials: 'include',
  }),
});
